// src/pages/buyer/LoyaltyPage.jsx
import { useQuery } from '@tanstack/react-query'
import { Gift, Star, TrendingUp } from 'lucide-react'
import { loyaltyApi } from '../../api/services'
import { Card, CardHeader, CardBody, PageSpinner, StatusBadge } from '../../components/common/ui'

export default function LoyaltyPage() {
  const { data, isLoading } = useQuery({ queryKey: ['loyalty'], queryFn: () => loyaltyApi.balance() })
  if (isLoading) return <PageSpinner />
  const payload = data?.data?.data || {}
  const { balance = 0, transactions = [], config = {} } = payload

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6 flex items-center gap-2"><Gift size={20} className="text-pink" /> Loyalty Points</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="bg-gradient-brand rounded-2xl p-5 text-white col-span-1">
          <p className="text-sm opacity-80 mb-1">Your Balance</p>
          <p className="text-4xl font-display font-bold">{Number(balance).toLocaleString('en-IN')}</p>
          <p className="text-xs opacity-70 mt-1">Points</p>
        </div>
        {[
          { label: 'Earn Rate', value: `${config.earn_per_100 ?? 1} pt per ₹100` },
          { label: 'Redeem Value', value: `₹${config.redeem_value ?? 0.25} per point` },
        ].map(({ label, value }) => (
          <div key={label} className="bg-white border border-border rounded-2xl p-5">
            <p className="text-xs text-muted mb-1">{label}</p>
            <p className="text-lg font-bold text-gray-900">{value}</p>
          </div>
        ))}
      </div>

      <Card>
        <CardHeader><span className="font-bold text-sm">Transaction History</span></CardHeader>
        <CardBody className="p-0">
          {transactions.length === 0 && <p className="text-sm text-muted text-center py-8">No transactions yet.</p>}
          {transactions.map((tx, i) => (
            <div key={i} className="flex items-center justify-between px-5 py-3 border-b border-border last:border-b-0">
              <div>
                <p className="text-sm font-medium text-gray-800">{tx.description || tx.reason || tx.type}</p>
                <p className="text-xs text-muted">{new Date(tx.created_at).toLocaleDateString('en-IN')}</p>
              </div>
              <span className={`text-sm font-bold ${tx.points > 0 ? 'text-green-600' : 'text-red-500'}`}>
                {tx.points > 0 ? '+' : ''}{tx.points} pts
              </span>
            </div>
          ))}
        </CardBody>
      </Card>
    </div>
  )
}
